import { gql } from '@apollo/client'

export const GET_PAGES_QUERY = gql`
  query getPages(
    $filter: pages_filter
    $translations_filter: pages_translations_filter
    $titles_translations_filter: titles_translations_filter
    $subtitles_translations_filter: subtitles_translations_filter
    $cards_translations_filter: cards_translations_filter
    $rich_texts_translations_filter: rich_texts_translations_filter
    $texts_with_images_translations_filter: texts_with_images_translations_filter
    $images_translations_filter: images_translations_filter
  ) {
    pages(filter: $filter) {
      meta_title
      meta_description
      slug
      translations(filter: $translations_filter) {
        meta_title
        meta_description
      }
      content {
        item {
          __typename
          ... on titles {
            id
            title
            translations(filter: $titles_translations_filter) {
              title
            }
          }
          ... on subtitles {
            id
            subtitle
            translations(filter: $subtitles_translations_filter) {
              subtitle
            }
          }
          ... on cards {
            id
            header
            text
            markets {
              markets_code {
                code
              }
            }
            translations(filter: $cards_translations_filter) {
              header
              text
            }
          }
          ... on rich_texts {
            id
            rich_text
            translations(filter: $rich_texts_translations_filter) {
              rich_text
            }
          }
          ... on texts_with_images {
            id
            header
            text
            image_placement
            image {
              id
              title
              width
              height
            }
            translations(filter: $texts_with_images_translations_filter) {
              header
              text
              image {
                id
                title
                width
                height
              }
            }
          }
          ... on images {
            image {
              id
              title
              width
              height
            }
            translations(filter: $images_translations_filter) {
              image {
                id
                title
                width
                height
              }
            }
          }
          ... on heroes {
            id
            background_color
            background_image {
              id
              title
              width
              height
            }
            blend_mode
            content_position
            fullscreen
          }
        }
      }
    }
  }
`
